export default {
  heading: "Accounting Services Agency",
  published: "Published on",
  zero_posts: "No blog posts added yet",
  menu_btns: {
    welcome: "Welcome",
    services: "Services",
    accounting: "Accounting",
    social_services: "Social Services",
    about_us: "About Us",
    price_list: "Price List",
    promotions: "Promotions",
    promotion_accounting: "Promotion - Accounting",
    promotion_services: "Promotion - Services",
    forms: "Forms",
    contacts: "Contacts",
    blog: "Blog",
  },
  routes: {
    welcome: {
      intro:
        "is a licensed accounting office in the UK. We are officially registered as a tax and customs agent in the United Kingdom - HMRC. We are subject to Anti Money Laundring Supervision, we have Professional Indemnity Insurance, and we are registered with the Information Commissioner's Office (ICO), responsible for personal data protection.",
      heading: "What do we offer?",
      p1:
        "As a licensed accountant, we represent you before the UK tax office in connection with your tax affairs.",
      p2:
        "We have two offices - DoKument and Biurokrat, where we offer the following services:",
      p3:
        "In our DoKument office, we provide a full range of accounting services, both for self-employed individuals - self employed / sole traders, and for corporate companies - Limited Companies. The full package of our services can be found ",
      p4:
        "In our Biurokrat office, we provide a full range of social services - translations into Bulgarian and Polish by licensed translators, assistance in applying for social benefits in the UK, child benefits, refunds of overpaid taxes and insurance, maternity and more. You can see the full package of our services ",
      p5:
        "In our many years of practice in the UK, we have managed to prove ourselves as specialists, as well as to create good relationships with customers, to respond to inquiries in the shortest possible time. We have hundreds of appeals won against us, against fines imposed by the tax authorities. Complying with legal regulations, our aim is to provide the most optimal solution for your business and its development. We consider each client's case strictly individually, and our experience has helped us communicate with the client in an accounting language understandable to both parties. These are prerequisites for having a rich portfolio of clients.",
      p6:
        'To stimulate our regular and satisfied customers, we have developed a promotional program "Recommend to a friend", the terms of which can be found ',
      conclusion: "Hundreds of businesses have trusted us! Trust us too!",
      span_here: "here",
      footer: {
        office: "Office",
        open_hours: "Open hours:",
      },
    },
    accounting: {
      heading: "Accounting services",
      top: {
        limited_companies: {
          vat_returns: "(VAT returns)",
          ltd: "Registration of Ltd.",
        },
        solo_trader: {
          register: "Registration as a self-employed person",
          decl: "Annual tax return",
          vat: "(VAT return)",
        },
        insurance: {
          heading: "Business insurance",
          importance:
            "It is extremely important to have business insurance in order to have coverage in case a customer is dissatisfied with your services and files a claim for damages.",
          employer:
            "If you are an employer, you have a legal obligation to have liability insurance.",
          responsible: "Do not underestimate these responsibilities!",
        },
      },
      bottom: [
        {
          heading:
            "The differences between a sole trader and a limited company",
          content:
            "See our definitions, compare the advantages and disadvantages and find out which business structure best suits your needs. Every business - no matter how big or small - must have a legal structure. In the UK, around 3.3 million work as sole traders, and 1.6 million work as LTD. What is the difference between the two? And what would be best for your business?",
        },
        {
          heading: "Sole trader (self-employed)",
          content:
            "A sole trader is essentially a self-employed person who is the sole owner of his business. This is the simplest business structure - which makes it the most popular. Registration for tax purposes is easy and straightforward.",
        },
        {
          heading: "Limited Liability Company (LTD)",
          content:
            "A limited liability company is a type of business structure that has its own legal identity, separate from its owners (shareholders) and its managers (directors). This remains the case even if it is managed by one person, in the capacity of shareholder and director. Sole proprietor or limited liability company? Each structure has its advantages and disadvantages, so let's take a closer look at the sole trader option",
        },
        {
          heading: "Sole trader - advantages",
          content:
            "It is easy to create a relatively small amount of paperwork, necessary tax switching once a year. Greater confidentiality than a limited liability company whose data can be viewed through Companies House.",
        },
        {
          heading: "Sole trader - disadvantages",
          content:
            "Sole traders have unlimited liability as they are not treated as a separate legal entity under UK law. This means that if the business falls into debt, the owner of the company is personally responsible. Thus, sole traders can lose their personal assets if things go wrong. Bank financing can be difficult, as banks and other investors prefer limited liability companies. This limits the scope for expansion of sole traders. Tax rates for sole traders are not always as generous as they are for limited liability companies. When you reach a certain level of profit, it becomes unprofitable to remain a sole trader. So, what are the pros and cons of setting up a limited bring company?",
        },
        {
          heading: "Advantages of the limited liability company",
          content:
            "Unlike the sole trader, the limited liability company has the advantage of limited liability because there is a legal distinction between the owner of the company and his actions. This means that personal assets are not at risk of loss, only what you have invested in the company. Generally speaking, limited liability companies are more tax efficient than sole traders. At present, the tax rates for profit taxation are lower for limited liability companies than for sole proprietors. In addition, limited liability companies have the opportunity to write off a wide range of costs, which reduces profits and taxes due.",
        },
        {
          heading: "Disadvantages of the limited liability company",
          content:
            "The director of the limited liability company has legal obligations (Director's Fiduciary Responsibilities), which must be strictly performed, which in turn requires time and attention. The reports and declarations that have to be submitted to the tax office are significantly more complex and numerous, which requires either the director to spend more time or hire an accountant, which incurs additional costs. There are administrative fees for setting up, issuing reports and closing a limited liability company, which are paid to Companies House. Details of your company's directors and revenue need to be shown publicly. Not everyone likes this kind of transparency. Ultimately, it is very important to weigh the differences between a sole trader and a limited liability company,",
        },
      ],
      footer:
        "Do not rush to make a decision, consult, because each business is individual. Make informed choices to make sure you have laid the right foundation from the start.",
    },
    services: {
      heading: "Other social services",
      paragraphs: [
        {
          heading: "Recording an interview for the National insurance number",
          content:
            "The National Insurance Number (NINo) in the UK is absolutely necessary and important - if you are looking for a job, start a job or start a business. The National Insurance Number (NINo) is the number under which all your taxes and social security contributions are recorded. We will record the date and time for the issuance of NINo at the nearest Jobcentre.",
        },
        {
          heading: "Refund of overpaid taxes and insurances",
          content:
            "If you have worked on the wrong tax code or have not worked for a whole tax year, as well as when leaving the UK, you are more likely to have a refund tax. Contact us for a free calculation.",
        },
        {
          heading: "Maternity allowance",
          content:
            "Those of you who are not eligible for maternity leave by your employer can apply for maternity leave from the state. Contact us for a free consultation.",
        },
        {
          heading:
            "Child benefit and Social income for low-income people (Universal credit)",
          content:
            "If you work in the UK and have children or your income is low, there are social benefits you can apply for. Contact us to advise you on what benefits are available in the area where you live.",
        },
      ],
    },
    about_us: {
      ani: {
        job:
          "Anna Atanasova - Chief Accountant and owner of DoKument and Biurokrat offices",
        texts: [
          "Anna graduated from the University of Economics - Varna, Bulgaria with a degree in Finance and Accounting Control.",
          "While studying, in the period 2007-2009, Anna worked as an accountant for some of the most prestigious hotels and restaurants on the Bulgarian Black Sea coast.",
          "From 2011 to 2014, Anna studied and graduated from AAT Education in the UK.",
          "He started his internship in the UK as an accountant in 2015 for Biurokrat in Crewe. In 2016 he started to provide freelance accounting services under the name BAJ Accounting. Her dedication to work and her professionalism are an occasion for the company to grow, and Anna should look for a partner, in the person of her former employer - Mrs. Elena Cholakova, owner of Biurokrat office. As a result, in May 2020, an accounting office DoKument was opened, with owners - Anna Atanasova and Elena Cholakova, and from September 2020, Anna also became a co-owner of the office Biurokrat, Crewe.",
        ],
        hobby:
          "Outside of her work, Anna devotes herself to her family, with whom she loves to travel.",
      },
      elena: {
        job:
          "Elena Cholakova - Chief Accountant and owner of DoKument and Biurokrat offices",
        texts: [
          "Eli holds a degree in Business Administration from Thames Valley University, UK.",
          "In 2002, he began his practice in the UK as an operating accountant and payroll. In 2014, he established the Biurokrat office, where in 2015 he met Anna Atanasova. During this period, Ellie managed to qualify as an accountant at the Institute of Certified Bookkeepers. In 2016, Eli became a licensed Bulgarian translator and was registered in the local municipality as a representative of the Bulgarian community in the area. From the spring of 2019, Eli started working with BAJ Accounting, as a result of which in May 2020 he became a co-owner of this company with the already changed name - DoKument Ltd.",
        ],
        hobby:
          "Outside of her work, Ellie indulges in family, travel and cultural events",
      },
      radoslava: {
        job:
          "Radoslava Ivanova - operational accountant and secretary of the DoKument office",
        texts: [
          "Radi has been working with us since the opening of the Document Office in July 2020.",
          "Radi gained his experience as an operating accountant in Bulgaria, with 7 years of experience as one of the largest food producers in the country.",
          "From 2007 to 2012, Radi continued his experience in a company caring for people with hearing loss. There, in addition to administrative work, Radi managed to gain experience in communicating with people with various social problems.",
          "This is a prerequisite for Radi to find his dream job abroad as a member of our team.",
        ],
        hobby:
          "Apart from his work with us, Radi is the organizer of the current Bulgarian Folklore Dance Club - Telford. In her spare time, Radi loves to read books and pass on our culture and traditions abroad.",
      },
      boyana: {
        job:
          "Boyana Koleva - Operational Accountant and Social Assistance Advisor in the Biurokrat office",
        texts: [
          "Bobby graduated from the University of Varna with a degree in Economics, and continues her master's degree in Accounting at the University of Plovdiv, where she graduated in 2007.",
          "While studying, Bobby practiced as an operating accountant and auditor.",
          "From 2012 to 2014 he studied accounting in the UK, in particular - computerized accounting program Sage 50.",
          "Bobby started his internship in the UK at the end of 2017 for the Biurokrat office, where he continues to work to this day.",
        ],
        hobby: "In her spare time, Bobby devotes himself to his family.",
      },
      irena: {
        job:
          "Irena Darakchieva - Chief Assistant Accountant in DoKument office.",
        texts: [
          "Irena has been working with us since mid-November 2020.",
          "In her practice, Irena works with people of different nationalities, which provides a prerequisite for excellent communication with clients.",
          "Over the years, Irena has acquired qualifications that enable her to hold management positions in world-famous companies.",
          "The confidence and good communication she has, gave Irena the opportunity to take one of the most important positions in our team, namely the direct communication with you - the clients.",
        ],
        hobby:
          "In her free time, Irenka loves learning new things, getting rich professionally, and meeting friends.",
      },
    },
    pricelist: {
      headings: ["Description", "Price"],
      rows: [
        [
          "Limited Registration - Includes PAYE, VAT registration, and state fee",
          "£95.00",
        ],
        [
          "Limited Registration Complete - Includes PAYE, VAT registration, state fee and corporate bank account",
          "£135.00",
        ],
        [
          "Annual business statement, corporate tax return and year-end bills from £ 600.00 / £ 50.00 (month)",
          "@",
        ],
        ["Pay slips, annual employee cost is £ 60.00 / £ 5.00 (month)", "@"],
        [
          "VAT returns - £ 240.00 per year / £ 60.00 per quarter / £ 20.00 per month",
          "@",
        ],
        [
          "Annual self-insured declaration - self-settled tax declaration",
          "£100.00",
        ],
        ["Registration of self-employed people", "£35.00"],
        ["Registration in the construction system - CIS", "£20.00"],
        ["Opening a business account - Business account", "£60.00"],
        [
          "Business insurance - third party liability insurance package",
          "£30.00",
        ],
        ["Apply for a loan at Bounce Bank", "£50.00"],
        ["Universal credit", "£80.00"],
        [
          "P85 / P38 (refund of overpaid taxes) from £ 15.00 to £ 150.00",
          "10.00%",
        ],
        ["Child allowance", "@"],
        ["Children born in Great Britain *", "£30.00"],
        ["Children born outside Great Britain *", "£50.00"],
        ["Children born and residing in another European country *", "£70.00"],
        ["Recover a lost social security number", "£30.00"],
        ["Create a personal tax account", "£20.00"],
        ["Retirement loan application *", "£80.00"],
        ["Correction of the erroneous tax code", "£30.00"],
        ["Application for maternity allowance", "£50.00"],
      ],
      extra_tax: "* There is an additional charge for postage",
      price_avarage:
        "The prices are indicative and subject to change according to the specific case!",
    },
    contacts: {
      left_side: {
        title: "Contact us",
        labels: {
          name: "Name",
          email: "E-mail",
          phone: "Phone",
          message: "Message",
        },
        btn_submit: "Send",
      },
      right_side: {
        title: "Do you need help?",
        title_secondary: "We are always ready to help you.",
        text:
          "Send us an inquiry directly by filling out this form easily, quickly and conveniently. Please enter your details correctly so that we can then contact you at the mail you entered.",
        office: "office",
        address: "Address",
        email: "E-mail",
        phone: "Phone",
        mobile_phone: "Mobile phone",
      },
      success_msg: "Thanks for contacting us! We will get back to you soon!",
    },
    promotions: {
      accounting: {
        heading_1: "PROMOTIONAL PROGRAM",
        heading_2: '"RECOMMEND TO A FRIEND"',
        intro: {
          p1:
            "Do you have a friend or colleague who needs accounting services?",
          p2: "Are you satisfied with us and want to recommend us?",
          p3: "We have developed a promotional program especially for you",
        },
        container_1: {
          heading: "What to do",
          p1:
            "Send us an email with the contacts of your friend or colleague - name, phone number, email.",
          p2:
            "If the person does not want to be provided with the contacts, then give the contacts to DoKument, and ask the client to give your names.",
        },
        container_2: {
          heading: "What will you get",
          p1:
            "For a recommendation to a prospective customer - self employed / sole trader, you will receive a gift card worth £ 10.00, which you can use in over 50 stores in the UK. You will receive the prize after the customer you have recommended has made a payment to us.",
          p2:
            "For a recommendation to a prospective customer with a Limited Company - you receive a gift card worth £ 50.00, which you can use in over 50 stores in the UK. The prize will be received after the client to whom you have recommended us has made 3 monthly payments to us, based on an annual payment plan.",
        },
        container_3: {
          heading: "Terms and conditions",
          p1: "The promotion is valid only for customers who pay us regularly.",
          p2:
            "The promotion is not valid for those of you who no longer work with us.",
          p3:
            "The promotion is valid only for future clients who will use accounting services - self employed / sole traders or Limited Companies.",
          p4:
            "The promotion is valid only for a recommendation to a future client who will use our service for the first time.",
        },
        terms: {
          p1:
            "The promotional program is valid from 17.08.2020 to 31.12.2020 inclusive **",
          p2:
            "** In case of abuse, we reserve the right to withdraw the promotion at any time without notice!",
        },
      },
      services: {
        heading_1: "PROMOTIONAL PROGRAM",
        heading_2: '"REGULAR CUSTOMERS"',
        intro: {
          p1: "Do you need to use our services?",
          p2: "Are you satisfied and need extra help?",
          p3: "We have developed a promotional program especially for you!",
        },
        container_1: {
          heading: "What does the program consist of?",
          p1:
            "Every client using the social services we offer can join the program.",
          p2:
            "The program is valid as a package for a family living at the same address.",
        },
        container_2: {
          heading: "What will you get",
          p1:
            "You will receive a gift card that you can use to shop in over 50 stores in the UK.",
          list: {
            heading:
              "The prize is received at the end of the month, depending on the monthly amount that the family has paid to us, or as follows:",
            items: {
              p1:
                "For monthly payments to us worth between £ 50 - £ 70 - you get a gift card for £ 5.00",
              p2:
                "For monthly payments to us worth between £ 70 - £ 120 - you get a gift card for £ 10.00",
              p3:
                "For monthly payments to us worth over £ 120 - you receive a gift card for £ 15.00",
            },
            conclusion:
              "The postage you pay us is NOT charged to service payments!",
          },
        },
        container_3: {
          heading: "Terms and conditions",
          p1: "The promotion is valid only for customers who pay us regularly.",
          p2:
            "The promotion is not valid for those of you who no longer work with us.",
          p3: "The promotion is valid for one family voucher only.",
          p4:
            "The promotion is valid only for clients who will use social services - social benefits, state maternity, child, service - refund of overpaid tax, and all others WITHOUT accounting of self-insured persons and Limited Companies.",
          conclusion:
            "The promotional program is valid from 01.10.2020 to 31.12.2020 inclusive **!",
        },
        footer:
          "** In case of abuse, we reserve the right to withdraw the promotion at any time without notice!",
      },
    },
    forms: {
      download_file: "Download file",
      dokument: {
        heading:
          "Forms and forms for accounting services that we perform in the DoKument office",
        p1: "You can use this form to report your business miles:",

        p2: "To report cash earnings, you can use this form:",

        p3: "To appoint a worker / director of work, use this form:",

        p4: "To report payments to subcontractors, use this form:",

        p5: "To register as self employed, fill out the following form:",

        p6: "To register a Limited Company, fill out the following form:",
      },
      biurokrat: {
        heading:
          "Forms for social services that we perform in the office Biurokrat",
        p1: "To apply for an insurance number, please use the following form:",
        p2: "To apply for Universal Credit, please use the following form:",
        p3:
          "To apply for disability assistance, please use the following form:",
        p4:
          "To request a reference for pension insurance, please use the following form:",
        p5: "To apply for child benefits, please use the following form:",
        p6:
          "For help enrolling a child / children in school, please use the following form:",
        p7:
          "To apply for a certificate - proof of experience in the UK, and / or recognition of health insurance, please use the following form:",
      },
    },
  },
  monday: "Monday:",
  tuesday: "Tuesday:",
  wednesday: "Wednesday:",
  thursday: "Thursday:",
  friday: "Friday:",
  saturday: "Saturday:",
};
